/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
/**
 * DeletecaseApi - axios parameter creator
 * @export
 */
export const DeletecaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete case
         * @summary DELETE case
         * @param {number} id case\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCase: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCase', 'id', id)
            const localVarPath = `/cases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeletecaseApi - functional programming interface
 * @export
 */
export const DeletecaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeletecaseApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete case
         * @summary DELETE case
         * @param {number} id case\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCase(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCase(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DeletecaseApi.deleteCase']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DeletecaseApi - factory interface
 * @export
 */
export const DeletecaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeletecaseApiFp(configuration)
    return {
        /**
         * Delete case
         * @summary DELETE case
         * @param {number} id case\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCase(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCase(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeletecaseApi - object-oriented interface
 * @export
 * @class DeletecaseApi
 * @extends {BaseAPI}
 */
export class DeletecaseApi extends BaseAPI {
    /**
     * Delete case
     * @summary DELETE case
     * @param {number} id case\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeletecaseApi
     */
    public deleteCase(id: number, options?: RawAxiosRequestConfig) {
        return DeletecaseApiFp(this.configuration).deleteCase(id, options).then((request) => request(this.axios, this.basePath));
    }
}

